// extracted by mini-css-extract-plugin
export var falconContainer = "_vp-2";
export var offerCenter = "_vp-0";
export var roktContainer = "_vp-1";